import { useState, useEffect } from 'react';
import { toInventoryCount } from '../api/inventory-request';

/**
 * Load stat-card counts in parallel for a module overview.
 *
 * `loaders` is a { key: () => Promise } map. A rejected loader resolves to 0 rather
 * than blanking the whole card row. The effect runs once on mount and is deliberately
 * NOT keyed on the pathname — re-entering the module from a deeper page should not
 * refire every request.
 */
export default function useOverviewStats(loaders) {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const entries = Object.entries(loaders);

    Promise.allSettled(entries.map(([, load]) => load())).then((results) => {
      if (!alive) return;
      const next = {};
      results.forEach((res, i) => {
        next[entries[i][0]] = res.status === 'fulfilled' ? toInventoryCount(res.value) : 0;
      });
      setStats(next);
      setLoading(false);
    });

    return () => { alive = false; };
    // Mount-only by design — see note above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { stats, loading };
}
